import { Modal, Form, Input, message } from 'antd'
import useForm from 'shared/hooks/useForm'
import { connect } from 'react-redux'
import { rpc } from 'shared/actions'
import get from 'lodash/get'
import schema from 'schema'
import React from 'react'

import './CleverInitModal.less'

const formItemLayout = {
  labelCol: {
    xs: { span: 24 },
    sm: { span: 7 }
  },
  wrapperCol: {
    xs: { span: 24 },
    sm: { span: 17 }
  }
}

const CleverInitModal = ({ onOk, rpc, ...rest }) => {
  const {
    handleSubmit,
    getFieldProps,
    getFieldError,
    isSubmitting,
    updateValues
  } = useForm({
    onSubmit: async vals => {
      try {
        await rpc('district.cleverInit', vals)
        message.success('District initialized.')
        return onOk()
      } catch (e) {
        message.error(
          get(
            e,
            'error.message',
            'Oops, something went wrong. Please try again.'
          )
        )
      }
    },
    initialValues: {
      cleverDistrictId: ''
    },
    validationSchema: schema.district.cleverInit
  })

  // ids get pasted, and the schema takes 24 hex characters and nothing else
  // - so surrounding whitespace would fail validation against an id that
  // looks perfectly correct
  const trimIdOnChange = e =>
    updateValues(values => ({
      ...values,
      cleverDistrictId: e.target.value.trim()
    }))

  return (
    <Modal
      {...rest}
      confirmLoading={isSubmitting}
      onOk={handleSubmit}
      title='Initialize Clever District'
    >
      <Form {...formItemLayout}>
        <Form.Item
          {...getFieldError('cleverDistrictId')}
          label='Clever District ID'
          extra='The district must have authorized the 9 Dots Clever app first.'
        >
          <Input
            {...getFieldProps('cleverDistrictId')}
            onChange={trimIdOnChange}
            autoFocus
            placeholder='Clever District ID'
          />
        </Form.Item>
      </Form>
    </Modal>
  )
}

/** @todo propTypes */

export default connect(null, { rpc })(CleverInitModal)
